import { FC } from "react";

type SubHeaderProps = {
  data: { [key: string]: string | number };
};

const SubHeader: FC<SubHeaderProps> = ({ data }) => {
  return (
    <div className="flex gap-2 flex-wrap">
      {Object.entries(data).map(([key, value], i) => {
        return (
          <div
            key={i}
            className="text-[#0A3690] font-bold"
          >{`${key}: ${value} ${
            i !== Object.keys(data).length - 1 ? "|" : ""
          }`}</div>
        );
      })}
    </div>
  );
};

export default SubHeader;
